import { Stack, Typography } from '@mui/material';
import AddExpertiseAction from './actions/add/AddExpertiseAction';
import CareerSectionTitle from 'domain/people/employee/CareerCapabilities/shared/CareerSectionTitle';

export const EmployeePortalHeader = () => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h6" color="primary">
        Expertise
      </Typography>
      <AddExpertiseAction />
    </Stack>
  );
};

export const CareerSectionHeader = () => {
  return (
    <CareerSectionTitle title="Expertise">
      <AddExpertiseAction />
    </CareerSectionTitle>
  );
};
